export default __webpack_public_path__ + "static/media/podium.8882d5f7.png";